import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import DocumentSection from '../../components/DocumentSection';
import Text from '../../components/Text';
import Box from '../../components/layout/Box';
import Section from '../../components/Section';
import { FormattedMessage } from 'react-intl';

function CookiePolicyModal({ show, setShow }) {
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Box className="flex-column">
            <Text variant="documentHeaderTitle">
              Cookiepolicy för kthbok.com
            </Text>
            <Text variant="documentHeaderSubtitle">
              Senast uppdaterad: 2023-09-24
            </Text>
          </Box>
        </Modal.Header>
        <Modal.Body>
          <DocumentSection
            title="1. Vad är kakor (cookies)?"
            texts={[
              `Kakor är små textfiler som lagras på din enhet när du besöker en
              webbplats. Dessa filer innehåller information om din webbläsning och
              användning av webbplatsen. Kakor används för att förbättra din
              upplevelse på webbplatsen genom att möjliggöra vissa funktioner och
              samla in anonym statistik om ditt besöksbeteende.`,
            ]}
          />

          <Section className="mt-3">
            <Text variant="documentSectionTitle">
              <FormattedMessage defaultMessage="2. Vilka typer av kakor används på vår webbplats?" />
            </Text>

            <Text variant="documentSectionSubtitle" className="mt-2">
              <FormattedMessage defaultMessage="Nödvändiga kakor" />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage={`Dessa kakor är avgörande för att webbplatsen ska fungera korrekt. De
            inkluderar kakor som möjliggör grundläggande funktionalitet, såsom
            navigering på sidan och åtkomst till säkra områden. Utan dessa kakor
            skulle webbplatsen inte fungera som den ska.`}
              />
            </Text>

            <Text variant="documentSectionSubtitle" className="mt-2">
              <FormattedMessage defaultMessage="Kakor från Google Analytics 4" />
            </Text>

            <Text variant="documentSectionText" className="mt-1">
              <FormattedMessage
                defaultMessage={`Vi använder Google Analytics 4, en tredjepartstjänst från Google,
                för att samla in anonym statistik om hur besökare använder vår
                webbplats. Denna information hjälper oss att förstå och förbättra
                webbplatsens prestanda och användarupplevelse. Google Analytics 4
                kakor samlar in data såsom sidvisningar, besökarens geografiska
                plats, webbläsartyp och enhetstyp. Informationen som samlas in är
                anonym och används enbart för att analysera besöksmönster på
                webbplatsen.`}
              />
            </Text>
          </Section>

          <DocumentSection
            title="3. Hur kan jag hantera kakor?"
            texts={[
              `Du har möjlighet att konfigurera användningen av kakor när du
              besöker vår webbplats. Om du inte accepterar kakor kan vissa delar
              av webbplatsen vara otillgängliga eller fungera mindre effektivt.`,
              `Om du vill ändra dina cookie-inställningar kan du göra det genom att
              klicka på Cookie-inställningar längst ner på sidan. Du kan också
              ändra cookie-inställningarna i din webbläsare. Om du vill veta mer
              om hur du gör detta, besök din webbläsares hjälpavsnitt.`,
            ]}
          />

          <DocumentSection
            title="4. Mer information"
            texts={[
              `För ytterligare information om hur vi hanterar din personliga
              information och integritet, vänligen läs vår datapolicy.`,
            ]}
          />

          <DocumentSection
            title="5. Kontakta oss"
            texts={[
              `Om du har några frågor eller funderingar om vår cookiepolicy,
              vänligen kontakta oss på kontakt@kthbok.com.`,
            ]}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Stäng
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CookiePolicyModal;
